export default __webpack_public_path__ + "static/media/system-chat-toggle.e1197137.svg";